// This file must be imported FIRST to make React globally available for styled-components
import React from 'react'

// Make React globally available
if (typeof window !== 'undefined') {
  window.React = React
}
if (typeof global !== 'undefined') {
  global.React = React
}
if (typeof globalThis !== 'undefined') {
  globalThis.React = React
}
